import { Product } from '@cast/console-types';

// order is important, it's used to determine the selected product
export const PRODUCT_BASE_PATHS = {
  reporting: '/reporting',
  automation: '/automation',
  llm: '/llm',
  dbo: '/dbo',
  settings: '/organization',
  security: '/security',
  apa: '/apa',
  auditLog: '/audit-log',
} satisfies Record<Product, string>;

export const BASE_PATHS = {
  notifications: '/notifications',
  /** OneClick clusters home (classic uses `/automation/cluster-list`). */
  clusters: '/clusters',
} as const;

// New activity URLs (replaces /audit-log and /notifications at top level)
export const ACTIVITY_PATHS = {
  activity: '/activity',
  activityEvents: '/activity/events',
  activityNotifications: '/activity/notifications',
} as const;

export const premiumFeaturePaths: string[] = [
  '/external-clusters/:clusterId/autoscaler',
  `${PRODUCT_BASE_PATHS.automation}/external-clusters/:clusterId/autoscaler`,
  '/external-clusters/:clusterId/rebalance',
  `${PRODUCT_BASE_PATHS.automation}/external-clusters/:clusterId/rebalance`,
  '/external-clusters/:clusterId/activity',
  '/external-clusters/:clusterId/cost-report/comparison',
  `${PRODUCT_BASE_PATHS.automation}/external-clusters/:clusterId/cost-report/comparison`,
];
export const nestedPaths: string[] = [
  '/external-clusters/:clusterId/rebalance/:rebalancingPlanId/*',
  `${PRODUCT_BASE_PATHS.automation}/external-clusters/:clusterId/rebalance/:rebalancingPlanId/*`,
  '/external-clusters/:clusterId/cost-report/workloads/compute-cost/:workloadName/:namespace/:workloadType',
  `${PRODUCT_BASE_PATHS.automation}/external-clusters/:clusterId/cost-report/workloads/compute-cost/:workloadName/:namespace/:workloadType`,
  '/external-clusters/:clusterId/cost-report/workloads/network-cost/:workloadName/:namespace/:workloadType',
  `${PRODUCT_BASE_PATHS.automation}/external-clusters/:clusterId/cost-report/workloads/network-cost/:workloadName/:namespace/:workloadType`,
  '/external-clusters/:clusterId/cost-report/workloads/efficiency/:workloadName/:namespace/:workloadType',
  `${PRODUCT_BASE_PATHS.automation}/external-clusters/:clusterId/cost-report/workloads/efficiency/:workloadName/:namespace/:workloadType`,
  '/external-clusters/:clusterId/nodes/:nodeId/*',
  `${PRODUCT_BASE_PATHS.automation}/external-clusters/:clusterId/nodes/:nodeId/*`,
];
